import { css } from '@emotion/css';
import cn from 'classnames';

import { getLinkTarget } from '@lyearn/core/utils/iframe';
import { useReactNodeView } from '@lyearn/lygo-core';

import { MENTIONS_PLUGIN_KEY } from '../../../plugins/Mentions';
import { MentionTypes } from '../const';

const mentionCss = css`
  color: #0065ff;
  background-color: #eff6ff;
  border-radius: 4px;
  cursor: pointer;
  padding-top: 3px;
  padding-bottom: 3px;
  &:hover {
    background-color: #dbeafe;
  }
`;

const MentionNodeView = () => {
  const { node, view } = useReactNodeView();

  if (!node || !view) return null;
  const state = MENTIONS_PLUGIN_KEY.getState(view.state);
  const UserTooltipProvider = state?.UserTooltipProvider;
  const linkTarget = getLinkTarget(node.attrs.href, node.attrs.href ? '_blank' : undefined);

  const anchorEle = (
    <a
      className={cn('mention px-2', mentionCss)}
      data-mention-id={node.attrs.id}
      data-mention-name={node.attrs.name}
      data-mention-type={node.attrs.type}
      href={node.attrs.href}
      rel="noopener noreferrer nofollow"
      target={linkTarget}
      title={node.attrs.name}>
      {'@' + node.attrs.name}
    </a>
  );

  if (node.attrs.type === MentionTypes.User && UserTooltipProvider)
    return <UserTooltipProvider userId={node.attrs.id}>{anchorEle}</UserTooltipProvider>;

  return anchorEle;
};

export default MentionNodeView;
